// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"Aj","cross":"Ak","iconSVGWrapper":"Al","iconSVG":"Am","iconSVGDark":"An"};